<template>
    <div>
        <slot>
            <b-container v-if="image">
                <b-row>
                    <b-col xs="6">
                        <img :src="image.src" :alt="image.alt"/>
                        <p>
                            <b-button class="md-primary" @click="closeSetPosition">Close</b-button>
                            <b-button class="md-primary" @click="acceptSetPosition">Save</b-button>
                        </p>
                    </b-col>


                    <b-col xs="6">
                        <div id="mapPhotoLocalisation" style="padding:0;width:100%; height:400px"></div>
                    </b-col>
                </b-row>
            </b-container>

            <div class="alert alert-danger" v-if="error">
                <button type="button" aria-hidden="true" class="close">×</button>
                <span>{{error}}</span>
            </div>
        </slot>

    </div>
</template>

<script>
  import firebase from 'firebase'

  const fb = require('@/firebaseConfig.js')
  import { mapState } from 'vuex'
  import fetch from 'node-fetch'
  /////////////
  import Vue from 'vue'

  import IcFirebaseUploader from 'ic-firebase-uploader'
  import 'ic-firebase-uploader/dist/ic-firebase-uploader.min.css'

  Vue.component('ic-firebase-uploader', IcFirebaseUploader)
  /////////////////
  import gmapsInit from '@/googleMapsConfig'

  /////////////////
  import SnapToRoute from '@/lib/SnapToRoute'
  import UIHelpersMixins from '@/mixims/UIHelpersMixins'
  const CommonLib = require('@/lib/Common')

  /////////////////

  export default {
    mixins:
              [
                UIHelpersMixins,
              ],
    props:    [
      'albumImages',
      'image',
      'trip',
      'readOnly'
    ],
    data ()
    {
      return {

        alert: '',

        initialSelected: [],

        currentPhotoMarker: null,

        map: null,
      }
    },
    mounted:  function () {

      // At this point, the child GmapMap has been mounted, but
      // its map has not been initialized.
      // Therefore we need to write mapRef.$mapPromise.then(() => ...)
      var that = this

      gmapsInit().then(function (google) {
        that.initMap()

          google.maps.event.addListenerOnce(that.map, 'tilesloaded', function () {


              that.reload()

          })
      })

    },
    methods:  {
      reload ()
      {
        var that = this
        if (!this.image || !this.trip)
        {
          return
        }

        //  setTimeout(function () {
        //    google.maps.event.addListenerOnce(that.map, 'idle', function () {

        var combinedPoly = new google.maps.Polyline({
          clickable:    false,
          strokeWeight: 4,
          map:          that.map,
        })

        var bounds = new google.maps.LatLngBounds()
        // Rebuild one long segment with all previous smaller segments
        that.trip.gpRoute_segments.forEach(function (key, value) {
          key.getPath().forEach(function (k, v) {
            combinedPoly.getPath().push(k)
            bounds.extend(k)
          })
        })
        that.map.fitBounds(bounds)

        that.setMapBounds(that.map, that.image)

        that.AddSnapMarkerToRoute(that.map, combinedPoly, that.image)

        // })
        //  },500)

      },

      initMap ()
      {
        // Regular Map
        const mapOptions = {
          zoom:                   6,
          center:                 new google.maps.LatLng(45.7, -73.90),
          mapTypeId:              google.maps.MapTypeId.TERRAIN,
          zoomControl:            false,
          mapTypeControl:         false,
          scaleControl:           false,
          panControl:             false,
          fullscreenControl:      false,
          navigationControl:      false,
          disableDoubleClickZoom: true,
          streetViewControl:      false,
          mapTypeControlOptions:  {
            style:      google.maps.MapTypeControlStyle.DROPDOWN_MENU,
            mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.HYBRID,
              google.maps.MapTypeId.SATELLITE, google.maps.MapTypeId.TERRAIN]
          },
          scrollwheel:            true,
          draggableCursor:        'crosshair',
          animation:              google.maps.Animation.BOUNCE,
          gestureHandling:        'cooperative',
          styles:                 [{
            'featureType': 'poi.attraction',
            'stylers':     [{
              'visibility': 'off'
            }]
          },
            {
              'featureType': 'poi.business',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'poi.medical',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'poi.place_of_worship',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'poi.school',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'transit.station.bus',
              'stylers':     [{
                'visibility': 'off'
              }]

            }
          ]
        }

        this.map = new google.maps.Map(document.getElementById('mapPhotoLocalisation'), mapOptions)
      },

      findMediaIndexByDate: function (haystack, needle) {
        for (var i = 0; i < haystack.length; i += 1)
        {
          if (haystack[i].id === needle.id)
          {
            return i
          }
        }
        return -1
      },

      setMapBounds: function (map, selectedImage) {
        var that = this

        var i = that.findMediaIndexByDate(that.albumImages, selectedImage)

        var iPrev   = i
        var prevPos = null
        while (iPrev >= 0 && !prevPos)
        {
          prevPos = that.albumImages[iPrev].latitude  && that.albumImages[iPrev].longitude
          if (!prevPos)
          {
            iPrev--
          }
        }

        var iNext   = i
        var nextPos = null
        while (iNext < that.albumImages.length && !nextPos)
        {
          nextPos = that.albumImages[iNext].latitude  && that.albumImages[iNext].longitude
          if (!nextPos)
          {
            iNext++
          }
        }

        if (nextPos && prevPos)
        {
          var bounds = new google.maps.LatLngBounds()
          bounds.extend(new google.maps.LatLng(that.albumImages[iPrev].latitude, that.albumImages[iPrev].longitude))
          bounds.extend(new google.maps.LatLng(that.albumImages[iNext].latitude, that.albumImages[iNext].longitude))
          map.fitBounds(bounds)

          if (map.getZoom() > 15)
          {
            map.setZoom(14)
          }

        }

      },

      AddSnapMarkerToRoute: function (map, poly, selectedImage, defaultPos) {
        var that = this
        var snapToRoute

        // Snap marker to route

        if (that.currentPhotoMarker)
        {
          that.currentPhotoMarker.setMap(null)
        }

        that.currentPhotoMarker = new google.maps.Marker({
          draggable: !this.readOnly,
          map:       map,
        })

        if (selectedImage.latitude  && selectedImage.longitude )
        {
          that.currentPhotoMarker.setPosition(new google.maps.LatLng(selectedImage.latitude, selectedImage.longitude))
        } else if (!this.readOnly)
        {
          that.currentPhotoMarker.setPosition(new google.maps.LatLng(map.getCenter().lat(), map.getCenter().lng()))
        }

        snapToRoute = new SnapToRoute(map, that.currentPhotoMarker, poly)
        //   map.fitBounds(bounds)

      }
      ,

      acceptSetPosition ()
      {
        var that = this

        var key = this.image.id
        fb.mediasCollection.doc(key).update({
          updatedOn:            new Date(),
          'metadata.latitude':  that.currentPhotoMarker.position.lat(),
          'metadata.longitude': that.currentPhotoMarker.position.lng(),
        }).then(() => {
          this.notifyVue('success', 'Photo position Saved ! Yay!')
          this.$emit('close')
        })
      },
      closeSetPosition ()
      {
        this.$emit('close')
      },

    }, // methods
    computed: {
      currentUser ()
      {
        return this.$store.getters.currentUser

      },
      error ()
      {
        return this.$store.state.error
      },
    },
    watch:    {

      trip:  function () {
        console.log('WATCH: trip')
        this.reload()
      },
      image: function () {
        console.log('WATCH: image')
        this.reload()
      },

      readOnly: function () {
        console.log('WATCH: readOnly')
        this.reload()
      },
    }
  }
</script>


<style lang="scss" scoped>


</style>